export const SLICE = 'slice';

export const DLX_BUNDLES_FEATURE_FLAG_KEY = 'dlx-bundles-search';

//TODO: Confirm if could be deleted
export const LIGHT_BUNDLE_TO_BUNDLE_CARD_FLAG_KEY = 'lightBundleToBundleCard';

export const DLX_SWAPPING_RULE_FLAG_KEY = 'dlx-swapping-rule';

export const ENHANCED_BUNDLE_UX_FEATURE_FLAG_KEY = 'enhanced-bundles-ux';

export const NEW_BUNDLES_FEATURE_FLAG_KEY = 'new-bundles';

export const ENABLE_DYNAMIC_ANCILLARIES = 'enable-dynamic-ancillaries';

export const REDIRECT_NEW_SEATS_COOKIE = 'SEATS_APP_ENABLED';

export const REDIRECT_NEW_SEATS_COOKIE_FLAG = 'redirect-new-seats-cookie';

export const BUNDLES_SKELETON_LOADER_FLAG = 'bundles-skeleton-loader';

export const GET_BASKET_FROM_API_ENABLED_FLAG = 'isGetBasketFromApiEnabled';

export const SHARED_UI_BASKET_FLAG_KEY = 'isSharedBasketUiEnabled';

export const HUMAN_SECURITY_FLAG_KEY = 'is-human-security-enabled';

export const DATADOME_TELEMETRIC_FLAG_KEY = 'is-datadome-telemetric-enabled';

export const FLEX_PASS_FLAG_KEY = 'isFlexPassEnabled';
